import { vizColor_hoverOpacity } from '@opengov/capital-style';
import { IReportConfigurationPresentation } from '@opengov/reporting-types';
import Color from 'color';

export const customColorFor = (presentationConfiguration: IReportConfigurationPresentation, category: string) => {
  const customColorForCategory =
    presentationConfiguration && presentationConfiguration.colors && presentationConfiguration.colors[category];
  if (customColorForCategory === null || customColorForCategory === undefined) return null;
  return customColorForCategory.hexValue;
};

export const customHighlightColorFor = (
  presentationConfiguration: IReportConfigurationPresentation,
  category: string
) => {
  const customColor = customColorFor(presentationConfiguration, category);
  if (customColor === null) {
    return null;
  }
  return Color(customColor).alpha(vizColor_hoverOpacity).rgb().string();
};
